// extracted by mini-css-extract-plugin
export var emailBlockLink = "_fs-0";